import {ListItem, ListItemText, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import React from "react";
import {useTheme} from "@mui/material/styles";

export const NavMenuListItem = ({linkTo, onClick, text}) => {
  const theme = useTheme();
  const isExternalLink = linkTo.startsWith('http://') || linkTo.startsWith('https://');
  return (
    <>
      {isExternalLink ? (
        <ListItem button
                  component={'a'}
                  href={linkTo}
                  target='_blank'
                  rel='noopener noreferrer'
                  sx={{
                    height: '35px',
                      '&:hover': {
                        background: '#fff',
                        boxShadow: 'inset 5px 5px 10px #bebebe, inset -5px -5px 10px #fff',
                        borderRadius: '50px',
                      }
                    }}
        >
          <ListItemText primary={text} sx={{ textAlign: 'center' }} primaryTypographyProps={{fontSize: '13px', fontFamily: 'Share'}}/>
        </ListItem>
        ) : (
          <ListItem button
                    component={Link}
                    to={linkTo}
                    onClick={onClick}
                    sx={{
                    height: '35px',
                      '&:hover': {
                        background: '#fff',
                        boxShadow: 'inset 5px 5px 10px #bebebe, inset -5px -5px 10px #fff',
                        borderRadius: '50px',
                      }
                    }}
                    >
            <ListItemText primary={text} sx={{ textAlign: 'center' }} primaryTypographyProps={{fontSize: '13px', fontFamily: 'Share'}}/>
          </ListItem>
        )}
      </>
  );
}


export const NavMenuDivider = ({ title }) => {
  const theme = useTheme();
  return (
    <Typography
      sx={{
        textAlign: 'center',
        fontSize: 18,
        p:1,
        backgroundColor: theme.palette.base.rothko1,
        color: 'white',
        textShadow: '0px 2px 5px rgba(0, 0, 0, 0.9)',
        // margin: 2,
      }}
    >
      {title}
    </Typography>
  );
}